import { observer } from 'mobx-react-lite';

import { cn } from '@/lib/utils';
import { userStore } from '@/stores/user.store';
import { handleMailTo } from '@/utils/platform';

import { Button, type ButtonProps } from '../ui';

type ContactUsButtonProps = {
  subject?: string;
  body?: string;
} & ButtonProps;

export const ContactUsButton = observer(
  ({ className, subject, body, onClick, ...props }: ContactUsButtonProps) => {
    const user = userStore.user;
    return (
      <Button
        size="sm"
        variant="secondary"
        className={cn('w-fit', className)}
        onClick={(event) => {
          handleMailTo(
            'support@littlebird.ai',
            subject || 'I need assistance',
            body || `Please support my account with: ${user?.email}`
          );
          onClick?.(event);
        }}
        {...props}
      >
        Contact Support
      </Button>
    );
  }
);
